import { HTTP_URL } from "../../config";

// The Past Games read API (server/history_api.go). Pages come back as
//   { records: [{ gameId, outcome, moves, durationSecs, endedAt }],
//     total }
// where total is the archive-wide finished-game count (the status
// bar's real number), not the loaded-row count.

export const HISTORY_PAGE_SIZE = 200;

export async function fetchHistoryPage({ beforeId = null, limit = HISTORY_PAGE_SIZE } = {}) {
  const url = new URL("/api/games", HTTP_URL);
  if (beforeId != null) url.searchParams.set("before_id", String(beforeId));
  url.searchParams.set("limit", String(limit));
  const res = await fetch(url);
  if (!res.ok) throw new Error(`history list failed (${res.status})`);
  const data = await res.json();
  return {
    total: typeof data.total === "number" ? data.total : null,
    records: (data.games ?? []).map((g) => ({
      gameId: g.game_id,
      outcome: g.outcome,
      moves: g.move_count,
      endedAt: g.ended_at,
      durationSecs: Math.max(
        0,
        Math.round((g.ended_at - g.started_at) / 1000),
      ),
    })),
  };
}

// A finished game's final board, as engine-state JSON (same shape the
// live wire uses; fanSize is absent and defaults visually to 1).
export async function fetchFinalBoard(gameId) {
  const res = await fetch(new URL(`/api/games/${gameId}/board`, HTTP_URL));
  if (!res.ok) throw new Error(`board fetch failed (${res.status})`);
  const data = await res.json();
  return data.board;
}
